import { render } from "./TicketBooking.vue?vue&type=template&id=290befef"
import script from "./TicketBooking.vue?vue&type=script&lang=js"
export * from "./TicketBooking.vue?vue&type=script&lang=js"

import "./TicketBooking.vue?vue&type=style&index=0&id=290befef&lang=css"

import exportComponent from "D:\\react js\\VET_VUE\\VET-mini-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__